export const viewOnlyUsersBalanceTableId = [
  11,
  // 6
];
export const viewOnlyUsersBalanceTableIdxName = {
  11: 'adm_stk',
  // 6: 'frontend'
};